<template>
    <div class="box" :style="computedStyle">
        <slot/>
    </div>
</template>

<script>
import Dimensionable from "../../mixins/Dimensionable";
    import {formatDimension} from "@spoferan/spoferan-ts-core";

    export default {
        name: "Box",

        mixins: [Dimensionable],

        props: {
            // Whether to persist the initial height, so it won't be adapted when the content changes
            persistHeight: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                persistedHeight: null
            }
        },

        computed: {
            computedStyle() {
                return {
                    maxHeight: this.maxHeightStyle,
                    maxWidth: this.maxWidthStyle,
                    minHeight: this.minHeightStyle,
                    minWidth: this.minWidthStyle,
                    width: this.widthStyle,
                    height: this.persistedHeight ? formatDimension(this.persistedHeight) : this.heightStyle,
                };
            }
        },

        watch: {
            persistHeight(persist) {
                if (persist) {
                    if (!this.height) {
                        this.persistedHeight = this.$el.offsetHeight;
                    }
                } else {
                    this.persistedHeight = null;
                }
            }
        },

        mounted() {
            this.$nextTick(function () {
                // If no explicit height is set, we fix the current height
                // This is especially required to keep dropdown menus with the same height when filtering on selects
                if (!this.height && this.persistHeight) {
                    this.persistedHeight = this.$el.offsetHeight;
                }
            });
        },

        methods: {
			// TODO: expose when migrating to Nuxt 3
            scrollToBottom() {
                this.$el.scrollTop = this.$el.scrollHeight;
            }
        },

    }
</script>
<style>
.box {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>